<template>
  <m-widget-betslip
    id="bet-slip"
    class="bet-slip"
    open
  >
    <template slot="left-head">
      <div class="caption">{{ $t('bet-slip.bet-slip') }}</div>
    </template>
    <template slot="right-head">
      <bet-slip-settings v-if="$store.state.isUserLoggedIn" />
    </template>
    <template slot="right-head" v-if="$store.state.isUserLoggedIn">
      <!--bet-slip-settings v-if="$store.state.isUserLoggedIn" /-->
      <!--div class="switcher" :class="{ ' switcher--on': props.switcher }" @click="changeSwitcher">
        <div class="switcher__point"></div>
      </div>
      <span style="font-size: 11pt; margin-top: 12px; margin-right: 10px; color: white;">{{ $t('bet-slip.fast-bet') }}:</span-->
      <!--bet-slip-fb v-if="$store.state.isUserLoggedIn" /-->
    </template>
    <!--div class="fast-bet" v-if="props.switcher">
      <div>Для того чтобы сделать ставку, щелкните на желаемом коэффициенте интересующего вас события</div>
      <div style="border-top: 1px solid rgba(255, 255, 255, .07); margin-top: 5px;">
        <div style="margin-top: 5px;">
          <span>{{ $t('bet-slip.amount') }}: </span>
          <input class="fast-bet-amount" type="text" v-model="fastBet"/>
          <span> {{ user.currency}}</span>
        </div>
      </div>
    </div-->
    <bet-slip-warning v-if="!$store.state.isUserLoggedIn">
      {{ $t('bet-slip.warnings.guest.0') }}<br>
      <m-textito @click="$store.commit('SHOW_MODAL', 'LOGIN')">{{ $t('bet-slip.warnings.guest.1') }}</m-textito>
      {{ $t('bet-slip.warnings.guest.2') }}
      <m-textito @click="$store.commit('SHOW_MODAL', 'REGISTER')">{{ $t('bet-slip.warnings.guest.3') }}</m-textito>
    </bet-slip-warning>
    <div class="bet-slip-success-message" v-else-if="success">{{ success }}</div>
    <!--bet-slip-warning v-else-if="!positions.length">
      {{ $t('bet-slip.warnings.empty.0') }}<br>
      {{ $t('bet-slip.warnings.empty.1') }}
      <m-textito>{{ $t('bet-slip.warnings.empty.2') }}</m-textito>
      {{ $t('bet-slip.warnings.empty.3') }}
    </bet-slip-warning-->
    <div class="bet-slip-body" v-else-if="positions.length">
      <div class="bet-slip-error-message" v-if="error">
        <p>{{ error }}</p>
        <ul v-if="errorList.length">
          <li v-for="(item, i) in errorList" :key="i">{{ item }}</li>
        </ul>
      </div>
      <div class="bet-slip-positions">
        <bet-slip-position v-for="position in positions" :key="[ position.event.id, position.id ].join(':')" :position="position" />
      </div>
      <bet-slip-options v-if="options.length > 1">
        <bet-slip-option v-for="option in options" :key="option.code" :option="option" />
      </bet-slip-options>
      <div class="bet-slip-info">
        <div class="flex bet-slip-info-item">
          <div class="label">{{ $t('bet-slip.total-stake') }}</div>
          <div class="value">{{ totalStake ? totalStake.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '0.00' }} {{ $store.state.user.currency }}</div>
        </div>
        <div class="flex bet-slip-info-item">
          <div class="label">{{ $t('bet-slip.maximum-return') }}</div>
          <div class="value">{{ maximumReturn ? maximumReturn.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : '0.00' }} {{ $store.state.user.currency }}</div>
        </div>
      </div>
      <div class="flex bet-slip-controls">
        <!--div class="bet-slip-clear-button" clickable name="close" @click="clear" >
          <i-trash-can-outline class="trash-can-outline" />
        </div-->
        <div class="left-flex">
          <color-button
            :disabled="false"
            color="yellow"
            @click="clear"
          >
            <span style="float: left;">
              <i-trash-can-outline style="font-size: 20px; margin-top: 4px; margin-right: 5px;"/>
            </span>
            <span style="float: right;">
              {{ $t('favorites.clear-all') }}
            </span>
          </color-button>
        </div>
        <div class="right-flex">
          <color-button
            :disabled="!placeable"
            color="yellow"
            @click="place"
          >
            {{ $t('bet-slip.place-bet') }}
          </color-button>
        </div>
      </div>
    </div>
    <div class="bet-slip-overlay" v-show="placing" />
  </m-widget-betslip>
</template>

<script>
import MTextito from '@/components/MTextito'
import MWidgetBetslip from '@/components/widget/MWidgetBetslip'
import Icon32 from '@/components/icons/Icon32'
import ColorButton from '@/components/buttons/ColorButton'
import BetSlipSettings from '@/components/bet-slip/BetSlipSettings'
import BetSlipWarning from '@/components/bet-slip/BetSlipWarning'
import BetSlipPosition from '@/components/bet-slip/BetSlipPosition'
import BetSlipOptions from '@/components/bet-slip/BetSlipOptions'
import BetSlipOption from '@/components/bet-slip/BetSlipOption'
import BetSlipFb from '@/components/bet-slip/BetSlipFb'
import ITrashCanOutline from 'vue-material-design-icons/TrashCanOutline'
import FridgeButton from '@/components/buttons/FridgeButton'

import { mapState } from 'vuex'

export default {
  components: { MTextito, MWidgetBetslip, Icon32, ColorButton, BetSlipSettings, BetSlipWarning, BetSlipPosition, BetSlipOptions, FridgeButton, BetSlipOption, ITrashCanOutline, BetSlipFb },
  computed: {
    ...mapState({
      positions: state => state.betSlip.positions,
      options: state => state.betSlip.options,
      totalStake: state => state.betSlip.totalStake,
      maximumReturn: state => state.betSlip.maximumReturn,
      placeable: state => state.betSlip.placeable,
      placing: state => state.betSlip.placing,
      user: state => state.user,
      quickBet: state => state.betSlip.quickBet,

      success: state => state.betSlip.success,
      error: state => state.betSlip.error,
      errorList: state => state.betSlip.errorList
    })
  },
  props: {
    switcher: false
  },
  data () {
    return {
      open: true,
      props: {
        switcher: false
      },
      fastBet: 10
    }
  },
  watch: {
    '$i18n.locale' (to, from) {
      this.$store.dispatch('betSlip/UPDATE_POSITIONS')
    },
    'maximumReturn' (to, from) {
      if (this.$store.state.betSlip.fastBet && this.$store.state.betSlip.fBOn === 1) {
        this.$store.dispatch('betSlip/PLACE')
      }
    },
    'fastBet' (to, from) {
      this.$store.commit('betSlip/PUT_QUICK_BET', { on: true, amount: this.fastBet })
      console.log(this.quickBet)
    }
  },
  mounted () {
    /* this.$store.dispatch('betSlip/GET_FASTBET')
    if (this.$store.state.betSlip.fBOn === 1) {
      this.props.switcher = true
    } else {
      this.props.switcher = false
    }
    this.$store.dispatch('betSlip/GET_FASTBET')
    this.fastbet = this.$store.state.betSlip.fastBet */
  },
  methods: {
    clear () {
      this.$store.commit('betSlip/CLEAR')
    },
    place () {
      this.$store.dispatch('betSlip/PLACE')
    },
    changeSwitcher () {
      console.log(this.quickBet)
      if (this.props.switcher === false) {
        this.$store.commit('betSlip/PUT_QUICK_BET', { on: true, amount: this.fastBet })
        this.props.switcher = true
      } else {
        this.$store.commit('betSlip/PUT_QUICK_BET', { on: false, amount: this.fastBet })
        this.props.switcher = false
      }
      console.log(this.quickBet)
    }
  }
}
</script>

<style scoped>
.bet-slip { border-bottom: 1px solid hsla(0,0%,100%,.07); padding: 0 10px; border: 2px solid #007354; margin-top: 10px; margin-left: 1px; margin-right: 10px; /* border-radius: 6px; */ }
.bet-slip-body { /* border-top: 2px solid black; padding: 0 10px; */ margin-bottom: 5px;  }
.bet-slip-overlay { background: rgba(0, 0, 0, .5); bottom: 0; left: -10px; position: absolute; right: -10px; top: 0; }
.bet-slip-success-message { background: #43a047; /* border-radius: 5px; */ padding: 10px; text-align: center; }
.bet-slip-error-message { background: #f44336; /* border-radius: 5px; */ margin-bottom: 10px; padding: 10px; }
.bet-slip-error-message ul { margin-left: 14px; }
.bet-slip-positions { display: flex; flex-direction: column; }
.bet-slip-position:not(:first-child) { margin-top: 5px; }
.bet-slip-info { margin: 10px 5px 0; }
.bet-slip-info-item { line-height: 24px; }
.bet-slip-info-item:not(:last-child) { border-bottom: 1px solid rgba(255, 255, 255, .07); }
.bet-slip-info-item .label { flex: 1 1; }
.bet-slip-controls { margin-top: 5px; /* padding-left: 9px; */ }
.bet-slip-clear-button { margin: -1px; cursor: pointer; }
.trash-can-outline { color: #ffdf1b; font-size: 24px; margin: 5px 0; }
.fridge-button { color: black; margin-top: 0px; }

.caption {
    color: #fff;
}

.switcher--disabled {
    opacity: .5;
    pointer-events: none;
}
.switcher {
    display: inline-block;
    vertical-align: middle;
    border-radius: 1em;
    cursor: pointer;
    position: relative;
    z-index: 1;
    font-size: 10px;
    width: 3em;
    height: 2em;
    margin-top: 11px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
    -webkit-transition: background-color .2s 50ms;
    transition: background-color .2s 50ms;
    background-color: var(--switcher-track-background-color, gray);
    margin-right: 10px;
}

.fast-bet-amount {
    background: rgba(0, 0, 0, .25);
    border: none;
    color: #fff;
    text-align: right;
    width: 100px;
}

.switcher__point {
    left: .2em;
    top: .2em;
    width: 1.6em;
    height: 1.6em;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.5);
    box-shadow: 0 1px 4px rgba(0,0,0,.5);
    background-color: #fff;
    margin-top: 2px;
}

.switcher.switcher--on .switcher__point {
    left: .2em;
    top: .2em;
    width: 1.6em;
    height: 1.6em;
    border-radius: 50%;
    -webkit-transition: -webkit-transform .2s;
    transition: -webkit-transform .2s;
    transition: transform .2s;
    transition: transform .2s,-webkit-transform .2s;
    -webkit-box-shadow: 0 1px 4px rgba(0,0,0,.5);
    box-shadow: 0 1px 4px rgba(0,0,0,.5);
    background-color: #fff;
    margin-top: 2px;
    float: right;
}

.switcher.switcher--on {
  background-color: #007354;
}

.fast-bet {
  background: hsla(0, 0%, 100%, .05);
  font-size: 14px;
  padding: 5px;
  position: relative;
  color: #cecece;
  margin-bottom: 5px;
}

.question { line-height: normal; padding: 5px 7px; }

.question-form {
  color: white;
  line-height: normal;
  padding: 11px 12px;
  border: 1px solid white;
}
</style>



// WEBPACK FOOTER //
// src/components/bet-slip/BetSlip.vue